// "use client";
// import { SearchIcon, Linkedin, Instagram, ExternalLink } from "lucide-react";
// import React, { useRef } from "react";
// import { motion, useInView, useScroll, useTransform } from "framer-motion";
// import { Button } from "../../../../components/ui/button";
// import { Image } from "@imagekit/next";
// import { useRouter } from "next/navigation";
// const Mentors = () => {
//   const folder = process.env.NEXT_PUBLIC_IMAGEKIT_FOLDER || "";
//   const mentors = [
//     {
//       id: 1,
//       name: "Niharika Jain Agrawal",
//       title: "Co-founder at Broomees",
//       expertise: "Shark Tank India S2 | Acumen Fellow | Antler Alumna",
//       image: "Niharika.jpeg",
//       linkedin: "https://www.linkedin.com/in/niharika-jain-agrawal-338766149/",
//       external: "https://www.youtube.com/watch?v=NztyF045MIc",
//       instagram: "https://www.instagram.com/niharikajainagrawal/",
//       rating: 4.9,
//       sessions: 88,
//     },
//     {
//       id: 2,
//       name: "Vaibhav Agrawal",
//       title: "Founder & CEO, Broomees",
//       expertise: "Shark Tank India S2 | Antler BLR02 | Social Alpha Grantee",
//       image: "vaibhav.jpeg",
//       linkedin: "https://www.linkedin.com/in/vaibhav24agr/",
//       external: "https://www.youtube.com/watch?v=NztyF045MIc",
//       instagram: "https://www.instagram.com/vaibhavagrawal2402/",
//       rating: 4.8,
//       sessions: 102,
//     },
//     // {
//     //   id: 2,
//     //   name: "Rubal Chib",
//     //   title: "Co‑Founder & CEO, qZense Labs",
//     //   expertise: "IoT + AI in Agri-tech | National Technology Awardee",
//     //   image: "/Rubal.jpeg",
//     //   linkedin: "https://www.linkedin.com/in/rubalchib/",
//     //   external : "",
//     //   instagram: "",
//     //   rating: 4.9,
//     //   sessions: 76,
//     // },
//     {
//       id: 3,
//       name: "Vimal Kumar",
//       title: "Startup Consultant & Tech Speaker",
//       expertise: "Featured on Shark Tank India",
//       image: "vimal.jpg",
//       linkedin: "https://www.linkedin.com/in/vimalkumarrn/",
//       external: "https://www.youtube.com/watch?v=9iNQKZHeWXQ",
//       instagram: "",
//       rating: 4.9,
//       sessions: 127,
//     },
//     {
//       id: 4,
//       name: "Shalin Wadhwa",
//       title: "Founder, Unparalleled Eats",
//       expertise: "Food-tech & HORECA growth specialist",
//       image: "shalin.jpeg",
//       linkedin: "https://www.linkedin.com/in/shalin-wadhwa-a0215853/",
//       external: "",
//       instagram:
//         "https://www.instagram.com/unparalleled_eats?igsh=ZmU0c20xcGs1dHRj",
//       rating: 4.8,
//       sessions: 95,
//     },
//     // {
//     //   id: 3,
//     //   name: "Vidit Bansal",
//     //   title: "Product & Growth Leader",
//     //   expertise: "Scaled B2B SaaS startups",
//     //   image:
//     //     "https://media.licdn.com/dms/image/v2/D5603AQHDkOo-2utvqg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1664840150632?e=1755734400&v=beta&t=r6Yv5uSfpQYxyhlwzpBp_bhf9LA_-GjXqLw54pG7060",
//     //   linkedin: "https://www.linkedin.com/in/viditb/",
//     //   external : "",
//     //   instagram: "",
//     //   rating: 4.7,
//     //   sessions: 112,
//     // },
//     // {
//     //   id: 4,
//     //   name: "Sameer Gangwar",
//     //   title: "Ex-Director @ Moglix | D2C Entrepreneur",
//     //   expertise: "Scaling B2B & D2C startups",
//     //   image:
//     //     "https://media.licdn.com/dms/image/v2/D4E03AQFDDQnxQCfHig/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1665151985984?e=1755734400&v=beta&t=37IfjqMQa22Hr7tHT001yrki5XgbHFyn0YTBVcvEixI",
//     //   linkedin: "https://www.linkedin.com/in/sameer-gangwar-47015440/",
//     //   external : "",
//     //   instagram: "",
//     //   rating: 4.9,
//     //   sessions: 140,
//     // },
//   ];

//   // Ref for scroll container
//   const containerRef = useRef(null);
//   const { scrollYProgress } = useScroll({
//     target: containerRef,
//     offset: ["start end", "end start"],
//   });

//   // Parallax effect for background blurs
//   const blurY1 = useTransform(scrollYProgress, [0, 1], [0, -100]);
//   const blurY2 = useTransform(scrollYProgress, [0, 1], [0, 50]);
//   const blurY3 = useTransform(scrollYProgress, [0, 1], [0, -50]);

//   // Ref for in-view detection
//   const contentRef = useRef(null);
//   const isInView = useInView(contentRef, { once: false, amount: 0.3 });

//   // Container animation
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.15,
//         delayChildren: 0.2,
//       },
//     },
//   };

//   // Item animation with scroll-triggered slide-in
//   const itemVariants = {
//     hidden: { y: 50, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: {
//         type: "spring",
//         stiffness: 100,
//         damping: 15,
//         duration: 0.6,
//       },
//     },
//   };

//   // Card animation with directional slide-in based on index
//   const cardVariants = (index) => ({
//     hidden: { x: index % 2 === 0 ? -100 : 100, opacity: 0 },
//     visible: {
//       x: 0,
//       opacity: 1,
//       transition: {
//         type: "spring",
//         stiffness: 120,
//         damping: 20,
//         duration: 0.5,
//       },
//     },
//     hover: {
//       scale: 1.03,
//       boxShadow: "0 10px 20px rgba(255, 174, 0, 0.2)",
//       transition: { duration: 0.3 },
//     },
//   });

//   const router = useRouter();
//   return (
//     <div className="bg-gradient-to-br from-[#FFFFFFE6] via-white to-[#FFAE00]/10 min-h-screen">
//       <div className="w-full mx-auto relative" ref={containerRef}>
//         {/* Decorative gradient blurs with parallax */}
//         <motion.div
//           className="absolute w-96 h-96 top-20 right-10 bg-[#FFAE00]/20 rounded-full blur-3xl"
//           style={{ y: blurY1 }}
//         />
//         <motion.div
//           className="absolute w-80 h-80 top-96 left-10 bg-[#FFAE00]/15 rounded-full blur-2xl"
//           style={{ y: blurY2 }}
//         />
//         <motion.div
//           className="absolute w-60 h-60 bottom-20 right-1/3 bg-[#FFAE00]/10 rounded-full blur-xl"
//           style={{ y: blurY3 }}
//         />

//         {/* Main content container */}
//         <div className="relative w-full min-h-screen" ref={contentRef}>
//           <motion.h2
//             className="font-bricolage font-bold text-yellow text-[50px] text-center tracking-[-0.50px] max-md:text-[32px]"
//             initial={{ opacity: 0, y: -20 }}
//             animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
//             transition={{ duration: 0.6, ease: "easeOut" }}
//           >
//             Meet the Mentors
//           </motion.h2>
//           <motion.p
//             className="font-bricolage font-semibold text-[#0D0D0D] text-3xl text-center tracking-[-0.30px] max-md:text-xl"
//             initial={{ opacity: 0, y: -20 }}
//             animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
//             transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
//           >
//             &ldquo;The best journeys are made with the right people beside
//             you.&rdquo;
//           </motion.p>

//           {/* Main content */}

//           <div className="flex flex-col lg:flex-row px-6 lg:px-16 mt-8 lg:mt-16 gap-12">
//             {/* Left side - Text content */}
//             <motion.div
//               className="flex-1 lg:pr-8"
//               variants={containerVariants}
//               initial="hidden"
//               animate={isInView ? "visible" : "hidden"}
//             >
//               <motion.h1
//                 className="font-bricolage font-bold text-[#1d1d1d] text-2xl sm:text-3xl md:text-[56px] tracking-[-0.75px] md:tracking-[-1.2px] leading-tight sm:leading-[40px] md:leading-[64px]"
//                 variants={itemVariants}
//               >
//                 <span className="text-[#0D0D0D]">Learn </span>
//                 <motion.span
//                   className="text-[#FFAE00]"
//                   whileHover={{ scale: 1.05 }}
//                   transition={{ duration: 0.2 }}
//                 >
//                   from
//                 </motion.span>
//                 <span className="text-[#0D0D0D]"> those who’ve </span>
//                 <motion.span
//                   className="text-[#FFAE00]"
//                   whileHover={{ scale: 1.05 }}
//                   transition={{ duration: 0.2 }}
//                 >
//                   walked the path
//                 </motion.span>
//                 <motion.span
//                   className="text-[#FFAE00]"
//                   whileHover={{ rotate: 360 }}
//                   transition={{ duration: 0.5 }}
//                 >
//                   .
//                 </motion.span>
//               </motion.h1>

//               <motion.p
//                 className="font-jakarta font-semibold text-[#1d1d1d] text-xs sm:text-sm md:text-lg leading-5 sm:leading-6 md:leading-8 max-w-lg"
//                 variants={itemVariants}
//               >
//                 Every trip is guided by a real-world mentor — entrepreneurs,
//                 creators, educators, and specialists — who don’t just teach, but
//                 walk alongside you. Their stories, insights, and guidance turn
//                 your journey into lasting transformation
//               </motion.p>

//               {/* CTA Buttons */}
//               <motion.div
//                 className="flex flex-col sm:flex-row gap-4 lg:gap-6 mt-12 lg:mt-16"
//                 variants={itemVariants}
//               >
//                 <motion.div
//                   whileHover={{ scale: 1.1, rotate: 2 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   <Button
//                     onClick={() => router.push("/Mentors")}
//                     className="bg-transparent border-2 border-[#FFAE00] text-[#0D0D0D] hover:bg-[#FFAE00] hover:text-[#0D0D0D] rounded-2xl h-16 lg:h-18 w-full sm:w-64 font-['Poppins',Helvetica] font-bold text-xl shadow-lg transition-all duration-300"
//                   >
//                     Meet a Mentor
//                   </Button>
//                 </motion.div>

//                 <motion.div
//                   whileHover={{ scale: 1.1, rotate: -2 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   <Button
//                     onClick={() => router.push("/Mentors")}
//                     className="bg-[#FFAE00]/20 backdrop-blur-sm border border-[#FFAE00]/30 rounded-2xl h-16 lg:h-18 w-full sm:w-64 shadow-lg flex items-center justify-center space-x-3 hover:bg-[#FFAE00]/30 transition-all duration-300"
//                   >
//                     <motion.div
//                       className="bg-[#FFAE00] rounded-full p-2"
//                       whileHover={{ rotate: 360 }}
//                       transition={{ duration: 0.5 }}
//                     >
//                       <SearchIcon className="w-5 h-5 text-[#0D0D0D]" />
//                     </motion.div>
//                     <span className="font-['Inter',Helvetica] font-semibold text-[#0D0D0D] text-lg">
//                       Explore All Mentors
//                     </span>
//                   </Button>
//                 </motion.div>
//               </motion.div>
//             </motion.div>

//             {/* Right side - Mentor profiles */}
//             <motion.div
//               className="flex-1 lg:pl-8"
//               variants={containerVariants}
//               initial="hidden"
//               animate={isInView ? "visible" : "hidden"}
//             >
//               <motion.h2
//                 className="font-['Inter',Helvetica] font-bold text-2xl lg:text-3xl text-[#0D0D0D] mb-8"
//                 variants={itemVariants}
//               >
//                 Featured Mentors
//               </motion.h2>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 {mentors.map((mentor, index) => (
//                   <motion.div
//                     key={mentor.id}
//                     className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-[#FFAE00]/20 hover:shadow-xl transition-all duration-300"
//                     variants={cardVariants(index)}
//                     initial="hidden"
//                     animate={isInView ? "visible" : "hidden"}
//                     whileHover="hover"
//                     transition={{ delay: index * 0.15 }}
//                   >
//                     <div className="flex items-start space-x-4">
//                       <motion.div
//                         className="relative"
//                         whileHover={{ scale: 1.15, rotate: 5 }}
//                         transition={{ duration: 0.3 }}
//                       >
//                         <Image
//                           width={64}
//                           height={64}
//                           src={`${folder}/${mentor.image}`}
//                           alt={mentor.name}
//                           className="w-16 h-16 rounded-full object-cover border-2 border-[#FFAE00]"
//                           loading="lazy"
//                           transformation={[
//                             {
//                               width: 128,
//                               quality: 100,
//                               dpr: "auto",
//                               format: "webp",
//                             },
//                           ]}
//                         />
//                         <motion.div
//                           className="absolute -bottom-1 -right-1 w-6 h-6 bg-[#FFAE00] rounded-full flex items-center justify-center"
//                           whileHover={{ scale: 1.2 }}
//                           transition={{ duration: 0.2 }}
//                         >
//                           <span className="text-[#0D0D0D] text-xs font-bold">
//                             ✓
//                           </span>
//                         </motion.div>
//                       </motion.div>

//                       <div className="flex-1">
//                         <motion.h3
//                           className="font-['Inter',Helvetica] font-bold text-[#0D0D0D] text-lg"
//                           whileHover={{ x: 5 }}
//                           transition={{ duration: 0.2 }}
//                         >
//                           {mentor.name}
//                         </motion.h3>
//                         <p className="text-[#0D0D0D]/70 text-sm font-medium">
//                           {mentor.title}
//                         </p>
//                         <p className="text-[#0D0D0D]/60 text-xs mt-1">
//                           {mentor.expertise}
//                         </p>

//                         <div className="flex items-center justify-between mt-3">
//                           <div className="flex items-center space-x-4">
//                             <motion.div
//                               className="flex items-center space-x-1"
//                               whileHover={{ scale: 1.1 }}
//                               transition={{ duration: 0.2 }}
//                             >
//                               {/* <span className="text-[#FFAE00] text-sm">★</span>
//                               <span className="text-[#0D0D0D] text-sm font-medium">
//                                 {mentor.rating}
//                               </span> */}
//                             </motion.div>
//                             {/* <span className="text-[#0D0D0D]/60 text-xs">
//                               {mentor.sessions} sessions
//                             </span> */}
//                           </div>

//                           <div className="flex items-center space-x-2">
//                             {mentor.linkedin && (
//                               <motion.a
//                                 href={mentor.linkedin}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="p-1.5 bg-[#FFAE00]/20 rounded-full hover:bg-[#FFAE00]/40 transition-colors duration-200"
//                                 whileHover={{ scale: 1.2, rotate: 15 }}
//                                 whileTap={{ scale: 0.9 }}
//                               >
//                                 <Linkedin className="w-4 h-4 text-[#0D0D0D]" />
//                               </motion.a>
//                             )}
//                             {mentor.instagram && (
//                               <motion.a
//                                 href={mentor.instagram}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="p-1.5 bg-[#FFAE00]/20 rounded-full hover:bg-[#FFAE00]/40 transition-colors duration-200"
//                                 whileHover={{ scale: 1.2, rotate: -15 }}
//                                 whileTap={{ scale: 0.9 }}
//                               >
//                                 <Instagram className="w-4 h-4 text-[#0D0D0D]" />
//                               </motion.a>
//                             )}
//                             <motion.button
//                               className="p-1.5 bg-[#FFAE00] rounded-full hover:bg-[#FFAE00]/80 transition-colors duration-200"
//                               whileHover={{ scale: 1.2 }}
//                               whileTap={{ scale: 0.9 }}
//                               onClick={() => {
//                                 if (
//                                   typeof window !== "undefined" &&
//                                   mentor.external
//                                 ) {
//                                   window.open(
//                                     mentor.external,
//                                     "_blank",
//                                     "noopener,noreferrer",
//                                   );
//                                 } else {
//                                   window.open(
//                                     mentor.linkedin,
//                                     "_blank",
//                                     "noopener,noreferrer",
//                                   );
//                                 }
//                               }}
//                             >
//                               <ExternalLink className="w-4 h-4 text-[#0D0D0D]" />
//                             </motion.button>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>

//               {/* <motion.div className="mt-8 text-center" variants={itemVariants}>
//                 <motion.button
//                   className="text-[#FFAE00] font-['Inter',Helvetica] font-semibold text-lg hover:text-[#FFAE00]/80 transition-colors duration-200"
//                   whileHover={{ scale: 1.1, x: 10 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   View All Mentors →
//                 </motion.button>
//               </motion.div> */}
//             </motion.div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Mentors;



"use client";

import { Search as SearchIcon, Linkedin, Instagram, ExternalLink, Check } from "lucide-react";
import React, { useRef } from "react";
import { motion, useInView, useScroll, useTransform } from "framer-motion";
import { Button } from "../../../../components/ui/button";
import { Image } from "@imagekit/next";
import { useRouter } from "next/navigation";

const MentorImage = ({ src, alt, folder }) => {
  const [loaded, setLoaded] = React.useState(false);
  return (
    <Image
      width={84}
      height={84}
      src={`${folder}/${src}`}
      alt={alt}
      className={`relative w-22 h-22 rounded-full object-cover border-4 border-white shadow-lg grayscale group-hover:grayscale-0 transition-all duration-700 ${loaded ? 'opacity-100' : 'opacity-0'}`}
      onLoad={() => setLoaded(true)}
      loading="lazy"
    />
  );
};

const Mentors = () => {
const folder = process.env.NEXT_PUBLIC_IMAGEKIT_FOLDER || "";
const router = useRouter();
const containerRef = useRef(null);
const contentRef = useRef(null);
const isInView = useInView(contentRef, { once: false, amount: 0.2 });

const [currentIndex, setCurrentIndex] = React.useState(0);
const [itemsPerPage, setItemsPerPage] = React.useState(2);
const [isHovered, setIsHovered] = React.useState(false);

React.useEffect(() => {
  const updateItemsPerPage = () => {
    // Show 1 card on everything below desktop (lg), 2 cards on desktop
    setItemsPerPage(window.innerWidth < 1024 ? 1 : 2);
  };
  updateItemsPerPage();
  window.addEventListener("resize", updateItemsPerPage);
  return () => window.removeEventListener("resize", updateItemsPerPage);
}, []);

const mentors = [
{
id: 1,
name: "Aditya Arora",
title: "CEO, FAAD Capital | $40M SEBI-Registered CAT I AIF",
expertise: "Top 15 Startup Investor | Author – Startups of Bharat",
image: "AdityaArora.jpeg",
linkedin: "https://www.linkedin.com/in/thefaadguy/",
external: "",
instagram: "https://www.instagram.com/adi__arora/",
},
{
id: 2,
name: "Ashish Mittal",
title: "Investor | Stanford Seed Consultant | Ex-Google",
expertise: "Ex-Google professional | Stanford Seed Consultant",
image: "ashish.jpeg",
linkedin: "https://www.linkedin.com/in/mittalashish/",
external: "",
instagram: "https://www.instagram.com/ashishmittal01/",
},
{
id: 3,
name: "Niharika Jain Agrawal",
title: "Co-founder at Broomees",
expertise: "Shark Tank India S2 | Acumen Fellow | Antler Alumna",
image: "Niharika.jpeg",
linkedin: "https://www.linkedin.com/in/niharika-jain-agrawal-338766149/",
external: "https://www.youtube.com/watch?v=NztyF045MIc",
instagram: "https://www.instagram.com/niharikajainagrawal/",
},
{
id: 4,
name: "Vaibhav Agrawal",
title: "Founder & CEO, Broomees",
expertise: "Shark Tank India S2 | Antler BLR02 | Social Alpha Grantee",
image: "vaibhav.jpeg",
linkedin: "https://www.linkedin.com/in/vaibhav24agr/",
external: "https://www.youtube.com/watch?v=NztyF045MIc",
instagram: "https://www.instagram.com/vaibhavagrawal2402/",
},
{
id: 5,
name: "Vimal Kumar",
title: "Startup Consultant & Tech Speaker",
expertise: "Featured on Shark Tank India",
image: "vimal.jpg",
linkedin: "https://www.linkedin.com/in/vimalkumarrn/",
external: "https://www.youtube.com/watch?v=9iNQKZHeWXQ",
instagram: "",
},
{
id: 6,
name: "Shalin Wadhwa",
title: "Founder, Unparalleled Eats",
expertise: "Food-tech & HORECA growth specialist",
image: "shalin.jpeg",
linkedin: "https://www.linkedin.com/in/shalin-wadhwa-a0215853/",
external: "",
instagram: "https://www.instagram.com/unparalleled_eats?igsh=ZmU0c20xcGs1dHRj",
},
];

const handleNext = React.useCallback(() => {
  setCurrentIndex((prev) => (prev + 1 >= mentors.length - (itemsPerPage - 1) ? 0 : prev + 1));
}, [mentors.length, itemsPerPage]);

const handlePrev = () => {
  setCurrentIndex((prev) => (prev - 1 < 0 ? mentors.length - itemsPerPage : prev - 1));
};

React.useEffect(() => {
  const timer = setInterval(() => {
    if (isInView && !isHovered) handleNext();
  }, 3000);
  return () => clearInterval(timer);
}, [isInView, isHovered, handleNext]);

const visibleMentors = mentors.slice(currentIndex, currentIndex + itemsPerPage);

const { scrollYProgress } = useScroll({
target: containerRef,
offset: ["start end", "end start"],
});

const blurY1 = useTransform(scrollYProgress, [0, 1], [0, -150]);
const blurY2 = useTransform(scrollYProgress, [0, 1], [0, 100]);

return (
<div className="relative rounded-[8px] overflow-hidden bg-[#F2F2F2] py-20 lg:py-32" ref={containerRef}>
<div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_70%,transparent_100%)]" />

  <motion.div className="absolute w-[500px] h-[500px] -top-20 -right-20 bg-[#FFAE00]/10 rounded-full blur-[120px]" style={{ y: blurY1 }} />
  <motion.div className="absolute w-[400px] h-[400px] bottom-0 -left-20 bg-yellow-200/20 rounded-full blur-[100px]" style={{ y: blurY2 }} />

  <div className="container mx-auto px-6 relative z-10" ref={contentRef}>
    <div className="text-center mb-16 lg:mb-24">
      <motion.h2
        className="font-bricolage font-extrabold text-[#FFAE00] text-4xl md:text-6xl mb-4 tracking-tight"
        initial={{ opacity: 0, y: 20 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
      >
        Meet the Mentors
      </motion.h2>
      <motion.p className="font-bricolage font-semibold text-[#0D0D0D] text-lg md:text-2xl max-w-2xl mx-auto italic opacity-80">
        &ldquo;The best journeys are made with the right people beside you.&rdquo;
      </motion.p>
    </div>

    <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <div className="lg:col-span-5 space-y-8">
        <motion.h1 
          initial={{ opacity: 0, x: -30 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          className="font-bricolage font-bold text-[#1d1d1d] text-4xl md:text-6xl leading-[1.1] tracking-tight"
        >
          Learn from <span className="text-[#FFAE00]">visionaries</span> who&apos;ve walked the path.
        </motion.h1>

        <motion.p 
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          className="font-bricolage font-semibold text-[#0D0D0D] text-lg md:text-2xl italic opacity-80 leading-relaxed"
        >
          Every trip is guided by real-world mentors—entrepreneurs, creators, and specialists who don&apos;t just teach, but walk alongside you.
        </motion.p>

        <div className="flex flex-col sm:flex-row gap-4 pt-4">
          <Button onClick={() => router.push("/Mentors")} className="bg-[#FFAE00] text-[#0D0D0D] hover:bg-[#e59c00] rounded-xl h-16 px-8 font-jakarta font-bold text-lg shadow-xl active:scale-95 transition-all">
            Meet a Mentor
          </Button>
          <Button onClick={() => router.push("/Mentors")} variant="outline" className="border-2 border-gray-300 bg-white/50 backdrop-blur-md rounded-xl h-16 px-8 font-jakarta font-bold text-lg hover:bg-gray-100 flex items-center gap-2 active:scale-95 transition-all">
            <SearchIcon className="w-5 h-5 text-[#FFAE00]" />
            Explore All
          </Button>
        </div>
      </div>

      <div className="lg:col-span-7 flex flex-col gap-8" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        <div className={`grid gap-8 ${itemsPerPage === 1 ? 'grid-cols-1' : 'grid-cols-2'} h-[400px]`}>
            {visibleMentors.map((mentor, index) => (
              <motion.div
                key={`${mentor.id}-${currentIndex}`}
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -30 }}
                transition={{ 
                  type: "spring",
                  stiffness: 260,
                  damping: 20,
                  delay: index * 0.05
                }}
                className="group relative h-full"
              >
                <div className="relative bg-white border border-gray-200 rounded-[32px] p-8 h-full flex flex-col justify-between
                  shadow-[inset_0_4px_12px_rgba(0,0,0,0.1),0_10px_30px_-10px_rgba(0,0,0,0.1)] 
                  transition-all duration-700 overflow-hidden
                  group-hover:shadow-[0_30px_60px_rgba(255,174,0,0.2)]">
                  
                  <div className="absolute inset-0 pointer-events-none z-0 rounded-[32px] transition-all duration-1000 group-hover:shadow-[inset_0_0_80px_rgba(255,174,0,0.15)]" />

                  <div className="relative z-10 flex flex-col items-center text-center sm:text-left sm:items-start gap-4">
                    <div className="relative">
                      <MentorImage
                        src={mentor.image}
                        alt={mentor.name}
                        folder={folder}
                      />
                      <div className="absolute -bottom-1 -right-1 w-7 h-7 bg-[#FFAE00] rounded-full flex items-center justify-center border-2 border-white shadow-md">
                        <Check className="w-3.5 h-3.5 text-black stroke-[3]" />
                      </div>
                    </div>

                    <div className="flex-1 space-y-1.5 w-full">
                      <h3 className="font-bricolage font-bold text-[#0D0D0D] text-xl group-hover:text-[#FFAE00] transition-colors leading-tight truncate">
                        {mentor.name}
                      </h3>
                      <p className="text-[#FFAE00] text-xs font-bold tracking-widest uppercase font-jakarta truncate">
                        {mentor.title}
                      </p>
                      <p className="font-jakarta text-gray-500 text-sm leading-relaxed line-clamp-3">
                        {mentor.expertise}
                      </p>
                    </div>
                  </div>

                  <div className="relative z-10 flex items-center gap-3 pt-4 border-t border-gray-100">
                    {mentor.linkedin && (
                      <a href={mentor.linkedin} target="_blank" className="p-3 bg-[#F5F5F5] rounded-2xl text-gray-500 hover:text-[#0077B5] hover:bg-white transition-all shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] hover:shadow-lg">
                        <Linkedin className="w-4 h-4" />
                      </a>
                    )}
                    {mentor.instagram && (
                      <a href={mentor.instagram} target="_blank" className="p-3 bg-[#F5F5F5] rounded-2xl text-gray-500 hover:text-[#E4405F] hover:bg-white transition-all shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] hover:shadow-lg">
                        <Instagram className="w-4 h-4" />
                      </a>
                    )}
                    <button onClick={() => window.open(mentor.external || mentor.linkedin, "_blank")} className="p-3 bg-[#FFAE00]/10 rounded-2xl text-[#FFAE00] hover:bg-[#FFAE00] hover:text-white transition-all shadow-[inset_0_2px_4px_rgba(255,174,0,0.1)] hover:shadow-lg ml-auto">
                      <ExternalLink className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
        </div>

        <div className="flex items-center justify-center sm:justify-end gap-3 pt-4">
          <button 
            onClick={handlePrev}
            className="p-4 bg-white border border-gray-200 rounded-2xl text-gray-400 hover:text-[#FFAE00] hover:border-[#FFAE00] transition-all shadow-sm hover:shadow-md active:scale-90"
          >
            <svg className="w-6 h-6 transform rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7" /></svg>
          </button>
          <button 
            onClick={handleNext}
            className="p-4 bg-white border border-gray-200 rounded-2xl text-gray-400 hover:text-[#FFAE00] hover:border-[#FFAE00] transition-all shadow-sm hover:shadow-md active:scale-90"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7" /></svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
);
};

export default Mentors;